import React, { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useParams, useNavigate } from 'react-router-dom';
import { state } from '../../store/global';
import API from '../../lib/api';

import RegisterHeader from '../../components/common/register/RegisterHeader';
import Spinner from '../../components/common/Spinner';

import ClockIcon from '../../assets/images/clock.svg';
import SuccessIcon from '../../assets/images/success.svg';

export default function ConfirmKyc() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();
  const { id } = useParams(); // gets the dynamic segment from the URL
  const [kycData, setKycData] = useState({ kycStatus: '', tosStatus: '' });

  useEffect(() => {
    const confirmKyc = async () => {
      await API.post('auth/confirmKyc', { redirectUrlId: id })
        .then((res) => {
          const data = {
            kycStatus: res.data.kyc_status,
            tosStatus: res.data.tos_status,
          };
          setKycData(data);

          const redirectTimer = setTimeout(() => {
            if (
              res.data.kyc_status == 'approved' &&
              res.data.tos_status == 'approved'
            )
              navigate('/login');
          }, 3000);

          return () => clearTimeout(redirectTimer); // Cleanup function to clear timeout
        })
        .catch((err) => {
          console.log('err: ', err);
          setKycData({ kycStatus: 'Server error', tosStatus: 'Server error' });
        });
    };

    const ApiCallTimer = setTimeout(() => {
      confirmKyc();
    }, 10000);

    return () => clearTimeout(ApiCallTimer); // Cleanup function to clear timeout
  }, [id, navigate]);

  const goToPage = (path) => {
    navigate(path);
  };

  const stepNumber =
    kycData.kycStatus == 'approved' && kycData.tosStatus == 'approved' ? 3 : 2;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E7EFFF]">
      <div className="z-10 w-full lg:w-[1044px] bg-white rounded-[20px] shadow-xl ">
        {/* Top header */}
        <RegisterHeader
          currentStep={stepNumber}
          onClose={() => goToPage('/')}
        />

        {/* Body */}
        <div className="relative w-full py-6 md:py-10 px-8 md:px-20 lg:px-52 space-y-8 bg-[#F9F9F9] rounded-b-[0px] lg:rounded-b-[20px]">
          <div className="space-y-10">
            <div className="sm:px-15 py-17 space-y-5">
              <div className="w-full flex items-center justify-center">
                <img
                  src={
                    kycData.kycStatus == 'approved' &&
                    kycData.tosStatus == 'approved'
                      ? SuccessIcon
                      : ClockIcon
                  }
                  alt="Clock Icon"
                  className="w-[155px] h-[155px]"
                />
              </div>

              <div className="text-center">
                <div className="w-full min-h-[30px] flex items-center justify-center">
                  <p className="text-xl font-semibold leading-[20px] tracking-[0%] font-[#252B37]">
                    Estamos validando tu identidad
                  </p>
                </div>

                <div className="flex items-center justify-center">
                  <div className="pt-6 min-w-54 w-50 space-y-2">
                    <div className="text-base font-[#535862] font-normal leading-[20px] flex items-center space-x-4">
                      <p>Estado de KYC: </p>
                      {kycData.kycStatus == '' ? (
                        <Spinner customClass="w-4 h-4" />
                      ) : (
                        <p
                          className={`${
                            kycData.kycStatus == 'approved'
                              ? 'text-[#2A59C6]'
                              : kycData.kycStatus == 'rejected'
                              ? ''
                              : 'text-[#8fce00]'
                          }`}
                        >
                          {kycData.kycStatus}
                        </p>
                      )}
                    </div>

                    <div className="text-base font-[#535862] font-normal leading-[20px] flex items-center space-x-4">
                      <p>Estado de TOS: </p>
                      {kycData.tosStatus == '' ? (
                        <Spinner customClass="w-4 h-4" />
                      ) : (
                        <p
                          className={`${
                            kycData.tosStatus == 'approved'
                              ? 'text-[#2A59C6]'
                              : kycData.tosStatus == 'rejected'
                              ? ''
                              : 'text-[#8fce00]'
                          }`}
                        >
                          {kycData.tosStatus}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {kycData.kycStatus == 'approved' &&
                kycData.tosStatus == 'approved' && (
                  <p className="text-center">
                    Serás redirigido a la página de inicio de sesión después de
                    3 segundos...
                  </p>
                )}
            </div>

            {/* Footer */}
            <div className="text-xs text-gray-600 font-semibold leading-[20px] tracking-[0%]">
              ¿Necesitas ayuda?{' '}
              <a href="#" className="font-[500] text-[#092F7B]">
                Contactar a soporte
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
